import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';

// Survey APIs
const getSurveyList = async (params) => {
  const response = await http.get('/survey_form_templates', {
    params,
  });
  return response;
};

// Serialize survey list to select options format
const serializeSurveyList = (response) => {
  const surveys = response?.data?.survey_form_templates || [];
  return (
    surveys?.map((survey) => ({
      value: survey.id,
      label: survey.title,
    })) || []
  );
};

export const useSurveyList = () => {
  const params = {
    'filter_by[survey_type][is][]': 'candidate',
    'sort_by[created_at]': 'desc',
    'filter_by[status][is][]': 'published',
    page: 1,
    per_page: 50,
  };

  return useQuery({
    queryKey: ['get-survey-list'],
    queryFn: () => getSurveyList(params),
    select: serializeSurveyList,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
